import React, { Component } from "react";
import { format } from "date-fns";
import { Drawer, Progress, Row, Col } from "antd";
import StarRatings from "react-star-ratings";
import "antd/dist/antd.css";
import { FaStar } from "react-icons/fa";
import { BiAward, BiUserCircle } from "react-icons/bi";
import { GoSmiley } from "react-icons/go";
import { FiSmile } from "react-icons/fi";
import { CgSmileNone, CgSmileSad } from "react-icons/cg";
import "../../../styles/Review.scss";
import { getTripFeedBack } from "../../../services/boatListService"

// import avatar from '../../../src/images/hotel/person.png'

export default class Reviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = { reviewDetails: [] };
  }

  state = { visible: false };

  getBoatTripFeedback = async () => {
    const { BoatHouseId, BoatTypeId, BoatSeaterId } = this.props.reviewDetails
    console.log("response")
    let data = {
      "BoatHouseId": BoatHouseId,
      "BoatTypeId": BoatTypeId,
      "SeaterTypeId": BoatSeaterId
    }
    const res = await getTripFeedBack(data)
    console.log(res,res.data.Response,data)
     if(res.data.Response === "No Records Found !!!."){
      this.setState({ reviewDetails:[]})
    }else {
      console.log("resdata")
      this.setState({ reviewDetails: res.data })
    }
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
    console.log("feedback", this.props.reviewDetails)
    this.getBoatTripFeedback()
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    // const { reviewDetails } = this.props;
    const { reviewDetails } = this.state;
    console.log(this.state,"state")

    return (
      <>
        <span className="rlinkdiv ml-2" onClick={this.showDrawer}>
          Read more
        </span>
        {reviewDetails.map((review, index) => {
                     return (  <Drawer title="Ratings" width={400} className="Review-Drawer" onClose={this.onClose} visible={this.state.visible} bodyStyle={{ marginTop: 30, paddingBottom: 80 }}>
            <p className="Ratehead">
              <span>
                <BiAward size="25px" style={{ verticalAlign: "text-bottom" }} />
              </span>
              Ratings & Reviews
            </p>
            <Row justify={"center"}>
              <div
                style={{
                  marginTop: "5px",
                  height: "170px",
                  boxShadow: "0px 8px 16px 0px rgba(104, 100, 100, 0.2)",
                  position: "relative",
                  width: "170px",
                  borderRadius: "30px",
                  textAlign: "center",
                  padding: "20px",
                }}
                className="ratecard"
              >
                <Progress
                  type="circle"
                  strokeColor={{
                    "0%": "#108ee9",
                    "100%": "#87d068",
                  }}
                  status="active"
                  percent={review.Ratings * 20}

                  // percent={reviewDetails.Rating * 20}
                  // percent={4 * 20}
                />
                <div
                  style={{
                    color: "grey",
                    marginTop: "5px",
                    paddingBottom: "7px",
                    fontSize: "15px",
                  }}
                >
                  <FaStar style={{ marginBottom: "3px", color: "#5caa5c" }} />
                  {/* <span> {reviewDetails.Rating + " / 5"}</span> */}
                  {/* <span> {4 + " / 5"}</span> */}
                  <span> {review.Ratings + " / 5"}</span>
                </div>
              </div>
            </Row>

            <div
              style={{
                fontSize: "18px",
                color: "green",
                opacity: "0.9",
                textAlign: "center",
                marginTop: "15px",
              }}
            >
              {review?.Ratings >= "4" ? (
                <b>
                  {/* <img
                        src={rate5}
                        style={{ height: '130px', width: '130px' }}/> */}
                  <div>
                    <GoSmiley style={{ verticalAlign: "middle", marginTop: "-3px" }} />
                    <span> EXCELLENT</span>
                  </div>
                </b>
              ) : (
                review?.Ratings === "3" && (
                  <b>
                    {/* <img
                          src={rateGood}
                          style={{ height: '130px', width: '130px' }}
                        /> */}
                    <div>
                      <FiSmile style={{ verticalAlign: "middle", marginTop: "-3px" }} />
                      <span> GOOD</span>
                    </div>
                  </b>
                )
              )}
              {review?.Ratings === "1" ? (
                <base>
                  {/* <img
                        src={
                          'http://www.prematix.solutions/ttdc-hotel-testapi/image/43c897d696e681c0337a2421191119ae.gif'
                        }
                        style={{ height: '130px', width: '130px' }}
                      /> */}
                  <div>
                    <CgSmileSad style={{ verticalAlign: "middle", marginTop: "-3px" }} /> <span> POOR</span>
                  </div>
                </base>
              ) : (
                review?.Ratings === "2" && (
                  <b>
                    {/* <img
                          src={rateAvarage}
                          style={{ height: '130px', width: '130px' }}
                        /> */}
                    <div>
                      <CgSmileNone style={{ verticalAlign: "middle", marginTop: "-3px" }} />
                      <span> AVERAGE</span>
                    </div>
                  </b>
                )
              )}
            </div>

            <hr />
            {/* {reviewDetails.Feedback.map((fb, index) => {
           */}
            {reviewDetails.map((fb, index) => {
              return (
                <>
                  <Row style={{ marginTop: "-13px" }}>
                    <Col style={{ fontSize: "25px" }}>
                      {/* <img
                      src={avatar}
                      style={{
                        height: '35px',
                        width: '35px',
                      }}
                    /> */}
                      <BiUserCircle size="23px" style={{ verticalAlign: "bottom", opacity: "0.9" }} />
                    </Col>
                    &nbsp;
                    <Col>
                      <div
                        style={{
                          marginTop: "13px",
                          fontSize: "18px",
                          opacity: "0.9",
                          textTransform: "uppercase",
                          fontWeight: "600",
                        }}
                      >
                        {/* <p> {fb.Name}</p> */}
                        {/* <p> {"Ram"}</p> */}
                        <p> {fb.FirstName}</p>

                      </div>
                    </Col>
                    <Col>
                      <p
                        style={{
                          marginTop: "12px",
                          marginLeft: "8px",
                        }}
                      >
                        {console.log(review.Ratings)}
                        {/* <StarRatings rating={fb.FeedbackRating} starDimension="14px" starSpacing="1px" starRatedColor="gold" /> */}
                        <StarRatings rating={parseInt(fb.Ratings)} starDimension="14px" starSpacing="1px" starRatedColor="gold" />
                      </p>
                    </Col>
                  </Row>
                  {/* <div
                    style={{
                      marginLeft: "27px",
                      color: "#00000052",
                      fontSize: "12px",
                      marginTop: "-18px",
                    }}
                  >
                  
                    {"2021-1-21,10:40"}
                  </div> */}
                  <div
                    style={{
                      marginLeft: "26px",
                      marginTop: "10px",
                      fontSize: "16px",
                      fontWeight: "600",
                      opacity: "1",
                    }}
                  >
                    <p style={{ opacity: 0.7, fontWeight: 400 }}>
                      {/* {fb.FeedbackComment} */}
                      {/* {"Good"} */}
                      {fb.Comments}
                    </p>
                  </div>

                  <hr />
                </>
              );
            })}
          </Drawer>
        )})}
      </>
    );
  }
}
